"use client";

// KeylessMapLazy — the one code-split boundary for the keyless map (finding 8, cold load).
// `next/dynamic` fetches maplibre and its dependency chunk when a map first renders. FWLR-025-R2: only
// the four conditional hosts use it; MountainSelectModal keeps a static import (its lazy chunk never
// completed on the installed desktop build), so maplibre is back in the initial JS of design routes.
// `ssr: false` because KeylessMap is browser-only and no host server-renders a map. The placeholder keeps
// the box KeylessMap draws and publishes `data-map-state="loading"` (distinct from its "init"/"ready").
// KeylessMap itself, its props and every host's behaviour are unchanged. Measurements:
// docs/evidence/fwlr025-finding8-cold-load/RESULTS.md.

import dynamic from "next/dynamic";

const KeylessMap = dynamic(() => import("./KeylessMap"), {
  ssr: false,
  loading: () => (
    <div data-keyless-map data-map-state="loading" style={{ width: "100%", height: "100%", minHeight: 240 }} />
  ),
});

export default KeylessMap;
export type { KeylessMarker } from "./KeylessMap";
